import React from "react";

const styles = {
  Attivo: "bg-black text-white border-black",
  Ritirato: "bg-white text-black border-black",
  Smaltito: "bg-[#E60000] text-white border-black",
};

export const StatusBadge = ({ stato }) => {
  const cls = styles[stato] || styles.Attivo;
  return (
    <span
      data-testid={`status-badge-${stato?.toLowerCase()}`}
      className={`inline-flex items-center border-2 ${cls} px-2.5 py-1 text-[10px] font-black uppercase tracking-widest`}
    >
      {stato}
    </span>
  );
};

export default StatusBadge;
